import { I18nAvailableLanguage } from '@ahha/i18n/i18n'

import dictKo from '@/assets/dictionary/ko.json'
import dictEn from '@/assets/dictionary/en.json'
import dictKoCBTP from '@/assets/dictionary/ko_cbtp.json'
import dictEnCBTP from '@/assets/dictionary/en_cbtp.json'

const i18nConfig: I18nAvailableLanguage[] = [
  {
    language: 'en',
    dictionary: process.env.REACT_APP_USE_CBTP === 'true' ? dictEnCBTP : dictEn,
    language_display_name: 'English',
  },
  {
    language: 'ko',
    dictionary: process.env.REACT_APP_USE_CBTP === 'true' ? dictKoCBTP : dictKo,
    language_display_name: '한국어',
  },
]

export default i18nConfig
